import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class ResultsTeamsRoute extends Route 
{
	@service resultsAjax;
	@service store;
	
	model(params) 
	{
		var event_id = this.modelFor('event').id;
		
		var store = this.store;
		var type = store.modelFor('team-result');
		var serializer = store.serializerFor('team-result');
		
		return this.resultsAjax.request("/events/"+event_id+"/results/teams").then(function(results)
		{
			results.forEach(function(result)
			{
				store.pushPayload(result);
			});
		}).then(function()
		{
			return store.findRecord('Event', event_id);
		});
	};
	
	@action
	refreshModel()
	{
		this.refresh();
	};
}
